export var dataKey = 'text';


//////////////////
// WEBPACK FOOTER
// ../~/redux-form/es/util/eventConsts.js
// module id = 2986
// module chunks = 3